import type { AppState } from '../../../types'

export const getCrawlerJobs = ({ crawler }: AppState) => {
  return [crawler.started, crawler.finished]
}
